import { createTheme, ThemeOptions } from '@mui/material/styles';

export const baseThemeOptions: ThemeOptions = {
    typography: {
        button: {
            textTransform: 'none'
        }
    }
};

const theme = createTheme(baseThemeOptions);

export default theme;
